import type { ReactNode } from 'react';

import type { ApiRegistry } from './provider';
import { ApiContext } from './providers/context';

export interface ApiRegistryProviderProps {
  readonly registry: ApiRegistry;
  readonly children: ReactNode;
}

export function ApiRegistryProvider({ registry, children }: ApiRegistryProviderProps) {
  return <ApiContext.Provider value={registry}>{children}</ApiContext.Provider>;
}
